import { Navigate } from "react-router-dom";
import { useStytchMemberSession } from "@stytch/react/b2b";
import { useIsAdmin } from "../hooks/useIsAdmin";

interface PrivateWrapperProps {
    children: JSX.Element;
    requireAdmin?: boolean; // Optional prop to specify if admin is needed
}

const PrivateWrapper = ({ children, requireAdmin = false }: PrivateWrapperProps) => {
    const { session } = useStytchMemberSession();
    const currentUserIsAdmin = useIsAdmin();

    if (!session) {
        return <Navigate to="/authenticate" />;
    }

    if (requireAdmin && !currentUserIsAdmin) {
        return <Navigate to="/" />;
    }

    return children;
};

export default PrivateWrapper;
